import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_bath_all: FaireCategoryEntity = {
  token: "cat_bath-all",
  type: "category",
  name: "All bath",
  level: 3,
  parentToken: "cat_home-decor-bath",
  href: "/category/home-decor/bath",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
